import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CurrencyFormatterDirective } from './directives/currency-formatter.directive';
import { CurrencyFormatterPipe } from './pipe/currency-formatter-pipe.pipe';

@NgModule({
  declarations: [CurrencyFormatterDirective,CurrencyFormatterPipe],  // Declare the directive here
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CurrencyFormatterDirective,CurrencyFormatterPipe] 
})
export class SharedModule { }
